
(function($) { "use strict";


	// Accordion cards
	$('.section-accordion-cards').each(function () {

		$(this).find('.block-accordion-card__title').on('click', function(){
			$(this)
				.closest('.block-accordion-card')
				.toggleClass('js-active')
				// .find('.accordion__content')
				// .toggleClass('js-hidden');
		});
	});


	// Announcements
	$('.section-announcement').each(function () {
		$(this).find('.announcement__button').on('click', function(){

			$(this)
				.closest('.announcement__right')
				.siblings('.announcement__additional-info')
				.toggleClass('js-hidden')
		});
	});


})(jQuery);